import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { NotificationsProvider } from "@/context/NotificationsContext";
import { CartTransitionProvider } from "@/context/CartTransition";
import { Layout } from "@/components/Layout";
import { RequireBusiness, RequireAuth, RequireBaker } from "@/components/RouteGuards";

import PickBusiness from "@/pages/PickBusiness";
import SignIn from "@/pages/SignIn";
import SignUp from "@/pages/SignUp";
import ForgotPassword from "@/pages/ForgotPassword";
import AuthCallback from "@/pages/AuthCallback";
import Shop from "@/pages/Shop";
import Deals from "@/pages/Deals";
import About from "@/pages/About";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import LargeOrder from "@/pages/LargeOrder";
import OrderDetail from "@/pages/OrderDetail";
import MyOrders from "@/pages/MyOrders";
import Notifications from "@/pages/Notifications";
import Account from "@/pages/Account";

import { ManageShell } from "@/pages/manage/ManageShell";
import Dashboard from "@/pages/manage/Dashboard";
import Orders from "@/pages/manage/Orders";
import Products from "@/pages/manage/Products";
import Specials from "@/pages/manage/Specials";
import Reports from "@/pages/manage/Reports";
import Settings from "@/pages/manage/Settings";
import Accounts from "@/pages/manage/Accounts";

// Wraps a customer page with the storefront chrome + business guard.
const Shell = (el) => (
  <RequireBusiness>
    <Layout>{el}</Layout>
  </RequireBusiness>
);

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <NotificationsProvider>
          <BrowserRouter>
            <Toaster position="top-center" richColors closeButton />
            <CartTransitionProvider>
            <Routes>
              <Route path="/" element={<PickBusiness />} />
              <Route path="/sign-in" element={<SignIn />} />
              <Route path="/sign-up" element={<SignUp />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/auth/callback" element={<AuthCallback />} />

              <Route path="/shop" element={Shell(<Shop />)} />
              <Route path="/deals" element={Shell(<Deals />)} />
              <Route path="/about" element={Shell(<About />)} />
              <Route path="/product/:id" element={Shell(<ProductDetail />)} />
              <Route path="/cart" element={Shell(<Cart />)} />
              <Route path="/large-order" element={Shell(<LargeOrder />)} />
              <Route path="/order/:id" element={Shell(<OrderDetail />)} />

              <Route path="/my-orders" element={Shell(<RequireAuth><MyOrders /></RequireAuth>)} />
              <Route path="/notifications" element={Shell(<RequireAuth><Notifications /></RequireAuth>)} />
              <Route path="/account" element={Shell(<RequireAuth><Account /></RequireAuth>)} />

              <Route
                path="/manage"
                element={
                  <RequireBaker>
                    <ManageShell />
                  </RequireBaker>
                }
              >
                <Route index element={<Dashboard />} />
                <Route path="orders" element={<Orders />} />
                <Route path="products" element={<Products />} />
                <Route path="specials" element={<Specials />} />
                <Route path="reports" element={<Reports />} />
                <Route path="accounts" element={<Accounts />} />
                <Route path="settings" element={<Settings />} />
              </Route>

              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            </CartTransitionProvider>
          </BrowserRouter>
        </NotificationsProvider>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
